import { useEffect, useState } from "react";

import InputField from "../../../../../../../InputField/InputField";
import { CREDITS_OVERDAFT_LIMITS } from "../../../../../../types";

interface OverdraftInputProps {
  disabled?: boolean;
  setValue: any;
  value: string;
}

const OverdraftInput = ({ disabled, setValue, value }: OverdraftInputProps) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const validateOverdraftInput = (value: string): string => {
    const number = Number(value);
    if (number > CREDITS_OVERDAFT_LIMITS.Max) {
      return String(CREDITS_OVERDAFT_LIMITS.Max);
    }
    return value;
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const rawValue = event.target.value;
    const digitsOnly = rawValue.replace(/\D/g, ""); // Allow only numbers
    const sanitizedValue = digitsOnly.replace(/^0+(?!$)/, ""); // Remove all leading zeros, but allow "0" as a valid value
    const validatedValue = validateOverdraftInput(sanitizedValue);

    setValue(validatedValue);
    setInputValue(validatedValue);
  };

  return (
    <InputField
      testId="overdraft-input"
      onChange={handleOnChange}
      size="small"
      slotProps={{
        input: {
          inputMode: "numeric",
        },
      }}
      value={inputValue}
      inputStyleExceptions={{ width: "70px", height: "32px" }}
      customInputStyle={{ textAlign: "center" }}
      disabled={disabled}
    />
  );
};

export default OverdraftInput;
